// extracted by mini-css-extract-plugin
module.exports = {"stars":"_3LWZlK","yellow":"_32lA32","red":"_1rdVr6","bar-color-6":"_32OAwH","star-img":"_1wB99o"};